import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-RealEstateFraud',
    templateUrl: './RealEstateFraud.component.html',
    styleUrls: ['./RealEstateFraud.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RealEstateFraudComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
